import { useQuery } from '@tanstack/react-query';

import {
  DEFAULT_RETRY_COUNT,
  HTTP_ERROR_STATUS_CODES,
  queryKeys,
} from 'api/config';
import { useQueryHTTPRequest } from 'api/hooks/useHTTPRequest';

import { USER_MODES } from 'features/user/config';
import { useUserMode } from 'features/user/hooks';

const placeholderData = {
  userEmail: '',
  userName: '',
  userPicture: { url: '' },
  chatId: '',
  timezone: '',
};

export const useParticipantQuery = (email, options = {}) => {
  const userMode = useUserMode();

  const { request } = useQueryHTTPRequest();
  const {
    data,
    status,
    isFetching,
    isInitialLoading: isLoading,
    error,
  } = useQuery(
    [queryKeys.participant, email],
    ({ signal }) => request({ url: `/api/coach/clients/${email}`, signal }),
    {
      ...options,
      enabled: !!email && userMode === USER_MODES.hde,
      retry: (failureCount, error) =>
        failureCount < DEFAULT_RETRY_COUNT &&
        error.message !== HTTP_ERROR_STATUS_CODES.FORBIDDEN,
      staleTime: 60 * 1000,
    }
  );

  return {
    participant: data || placeholderData,
    status,
    isFetching,
    isLoading,
    error,
  };
};
